<template>
	<!-- Main Content -->
	<div class="container">
		<h3 class="p-3 text-center">Login do Usuário</h3>
		<!-- Este form serve para login -->
		<form id="formMatrix">
			<div id="divEmail" class="form-group row">
				<div class="row">
					<label for="email" class="col-sm-2 col-form-label" style="float: left">
						E-mail
					</label>
					<div class="col-sm-4">
						<input
							type="text"
							class="form-control"
							id="email"
							v-model="email"
							placeholder="E-mail"
						/>
					</div>
				</div>
			</div>

			<div id="divPassword" class="form-group row">
				<div class="row">
					<label for="passwd" class="col-sm-2 col-form-label" style="float: left">
						Senha
					</label>
					<div class="col-sm-4">
						<input
							type="password"
							class="form-control"
							id="passwd"
							v-model="passwd"
							placeholder="Senha"
						/>
					</div>
				</div>
			</div>

			<div id="divCaptcha" class="form-group row">
				<div class="row">
					<div class="col-sm-2"></div>
					<div class="col-sm-2">
						<!-- Captcha -->
						<div v-if="expired" id="expired">
							<h1>Challenge expired!</h1>
						</div>
						<div v-if="error" id="error">
							<h1>Error:</h1>
							<p>{{ error }}</p>
						</div>
						<vue-hcaptcha
							sitekey="98ceb645-6a20-4b30-8d03-b709323fd8d7"
							@verify="onVerify"
							@expired="onExpire"
							@challenge-expired="onChallengeExpire"
							@error="onError"
						></vue-hcaptcha>
					</div>
				</div>
			</div>

			<!-- Linha para o link "Esqueci minha senha" alinhado com o container do captcha -->
			<div id="divForgot" class="form-group row">
				<div class="col-sm-2"></div>
				<div class="col-sm-4" style="text-align: left;">
					<a href="#" @click="gerarNovaSenha" id="novaSenha">
						<span>Esqueci minha senha</span>
					</a>
				</div>
			</div>

                        <!-- NOVO bloco: link para criação de conta -->
                        <div id="divCreateAccount" class="form-group row">
                          <div class="col-sm-2"></div>
                          <div class="col-sm-4" style="text-align: left;">
                            <a
                              href="#"
                              @click="$router.push({ name: 'CadastroUsuario' })"
                              id="linkCriarConta"
                            >
                              <span>Clique aqui para criar uma conta</span>
                            </a>
                          </div>
                        </div>


			<!-- Linha para os botões "Avançar" e "Criar uma Conta" na mesma linha, com 30px de espaço entre eles -->
			<div id="divButtons" class="form-group row">
				<div class="col-sm-2"></div>
				<div class="col-sm-8" style="display: flex; align-items: center;">
					<!-- MODIF: Alterado para chamar handleAvancarClick ao invés de efetuarLogin diretamente -->
					<button
						id="buttonAvancar"
						@click.prevent="handleAvancarClick"
						type="submit"
						class="btn btn-sm btn-info"
					>
						Avançar
					</button>

<!--
					<button
						id="buttonCriarConta"
						@click.prevent="$router.push({ name: 'CadastroUsuario' })"
						type="submit"
						class="btn btn-sm btn-success"
					>
						Criar uma Conta
					</button>

-->
				</div>
			</div>
		</form>
	</div>

	<!-- MODIF: Modal de consentimento de cookies -->
	<div v-if="showCookieModal" class="modal-overlay">
		<div class="modal-content">
			<div class="modal-header">
				<!-- MODIF: Botão para fechar o modal -->
				<button class="modal-close-button" @click="closeModal">X</button>
			</div>
			<div class="modal-body">
				<p>
					Nosso website coleta informações do seu dispositivo e da sua navegação por meio de cookies ou mecanismos
					similares para mensurar a audiência do website. Ao clicar em ACEITO, você concordará com o uso deste(s)
					recurso(s).
				</p>
			</div>
			<div class="modal-footer">
				<button class="btn btn-primary" @click="acceptCookieConsent">ACEITO</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { ref } from 'vue'
	import SgaaApplication from '@/sgaa.application.js'
	import $ from 'jquery'
	import VueHcaptcha from '@hcaptcha/vue3-hcaptcha'
	import { useRouter } from 'vue-router'
	import { AES } from 'crypto-js'
	import { useLoginStore } from '../stores/LoginStore'
	import { enviarEmailUsuarioEsqueciSenha } from '@/mail.usermsg.js'
	import { gerarSenhaAlfanumerica } from '@/utils.security.js'

	export default {
		name: 'EfetuarLogin',
		components: { VueHcaptcha },
		setup() {
			const verified = ref(false)
			const expired = ref(false)
			const tokenCaptcha = ref('')
			const eKey = ref('')
			const error = ref('')

			let email = ref('')
			let passwd = ref('')
			let token = ref('')
			const router = useRouter()
			const loginStore = useLoginStore()

			// MODIF: Variável para controle do modal de cookies
			const showCookieModal = ref(false)

			function onVerify(tokenStr, ekey) {
				verified.value = true
				tokenCaptcha.value = tokenStr
				eKey.value = ekey
			}

			function onExpire() {
				verified.value = false
				tokenCaptcha.value = null
				eKey.value = null
				expired.value = true
			}

			function onChallengeExpire() {
				verified.value = false
				tokenCaptcha.value = null
				eKey.value = null
				expired.value = true
			}

			function onError(err) {
				tokenCaptcha.value = null
				eKey.value = null
				error.value = err
			}

			async function gerarNovaSenha() {
				// Gera nova senha de 8 dígitos e concatena com string para garantir padrão válido
				const novaSenha = gerarSenhaAlfanumerica(8).concat('1Aa@')

				const emailUsuario = prompt(
					'Por favor, digite o e-mail para envio da nova senha:'
				)
				if (!emailUsuario) {
					console.log('Acao cancelada pelo usuário')
				} else {
					let credential = {
						email: emailUsuario,
						password: novaSenha,
					}

					let response = await SgaaApplication.usuarioSenha(credential)

					if (response.status === 200) {
						console.log('Entrou status enviarEmailUsuarioSenha')
						enviarEmailUsuarioEsqueciSenha(credential)
						//navigating
						router.push({
							name: 'PaginaSucesso',
							params: {
								msg:
									'Uma nova senha foi gerada e enviada para o e-mail ' +
									credential.email +
									'. Verifique sua caixa de e-mail ou de spam, caso não tenha recebido.',
							},
						})
					}
				}
			}

			// MODIF: Função para exibir o modal ao clicar no botão Avançar
			function handleAvancarClick() {
				showCookieModal.value = true
			}

			// MODIF: Função para fechar o modal
			function closeModal() {
				showCookieModal.value = false
			}

			// MODIF: Função para aceitar o consentimento e seguir com o fluxo de login
			async function acceptCookieConsent() {
				closeModal()
				await efetuarLogin()
			}

			async function efetuarLogin() {
				let credential = {
					email: email.value,
					password: passwd.value,
				}

				$(async function () {
					if (
						!verified.value &&
						(tokenCaptcha.value == null || tokenCaptcha.value == '')
					) {
						alert('Oops, você tem de checar o Captcha')
					} else {
						const responseToken = await loginStore.fetchToken(credential)

						if (responseToken.status === 200) {
							token.value = responseToken.data.token

							// Criptografa o token e guarda na sessão
							let objToken = { token: token.value }
							const encryptedObject = AES.encrypt(
								JSON.stringify(objToken),
								'MYKEY4DEMO'
							)
							localStorage.setItem('token', encryptedObject.toString())
							// Verifica se usuário é admin
							await loginStore.checkUsuarioAdm(email.value)

							// Verifica se o usuário possui alguma notificação referente a requisição concluída
							await loginStore.checkRequisicaoConcluida()

							//navigating
							router.push('/home')
						} else if (
							responseToken.status === 400 ||
							responseToken.status === 401
						) {
							//navigating
							router.push({
								name: 'PaginaErro',
								params: {
									msg: responseToken.data[0].Alerta,
								},
							})
						} else if (responseToken.status === 404) {
							//navigating
							router.push({
								name: 'PaginaErro',
								params: {
									msg: 'Serviço está inacessível.',
								},
							})
						} else {
							//navigating
							router.push({
								name: 'PaginaErro',
								params: {
									msg: responseToken.data,
								},
							})
						}
					}
				})
			}

			return {
				email,
				passwd,
				token,
				loginStore,
				router,
				efetuarLogin,
				gerarNovaSenha,
				verified,
				expired,
				tokenCaptcha,
				eKey,
				error,
				onVerify,
				onExpire,
				onChallengeExpire,
				onError,
				// MODIF: Expondo as funções e variáveis do modal
				showCookieModal,
				handleAvancarClick,
				closeModal,
				acceptCookieConsent,
			}
		},
	}
</script>

<style scoped>
	h3 {
		margin: 40px 0 0;
		color: #000000;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	/*Bootstrap: Mudança da cor dos botões*/
	.btn-info {
		background-color: #3276b1;
		border-color: #3276b1;
		color: #ffffff;
	}

	/*Bootstrap: Mudança da cor dos botões*/
	.btn-success {
		background-color: #58b358;
		border-color: #58b358;
	}

	/*Evita a geração de scroll horizontal*/
	.row {
		margin-right: 0px;
		margin-left: 0px;
		margin-top: 15px;
	}

	.row-margin-top {
		margin-top: 15px;
	}

	/* MODIF: Estilos para o modal de consentimento de cookies */

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	/* ---------- MODIF INÍCIO : Tornar o modal responsivo ---------- */
	.modal-content {
		background: #fff;
		width: 90vw;               /* largura padrão para telas pequenas  */
		max-width: 500px;          /* evita crescer demais em desktops    */
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.5);
		display: flex;
		flex-direction: column;
		max-height: 80vh;          /* impede ultrapassar a altura da tela */
		overflow-y: auto;          /* cria rolagem se o texto for maior   */
	}

	@media (min-width: 576px) {   /* tablets em pé                      */
		.modal-content {
			width: 70vw;
		}
	}

	@media (min-width: 768px) {   /* tablets deitados                   */
		.modal-content {
			width: 50vw;
		}
	}

	@media (min-width: 992px) {   /* notebooks / desktops               */
		.modal-content {
			width: 30vw;
		}
	}
	/* ---------- MODIF FIM ---------------------------------------- */

	.modal-header {
		display: flex;
		justify-content: flex-end;
	}

	.modal-close-button {
		background: none;
		border: none;
		font-size: 1.2rem;
		cursor: pointer;
		line-height: 1; /* MODIF: aumenta área clicável sem crescer o X */
	}

	.modal-body {
		flex-grow: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		font-size: 1rem;
	}

	/* MODIF: reduz um pouco o tamanho da fonte em celulares pequenos */
	@media (max-width: 440px) {
		.modal-body {
			font-size: 0.875rem;
		}
	}

	.modal-footer {
		display: flex;
		justify-content: center;
	}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>

